import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import Sidebar from './Sidebar';
import ContextBar from './Header';
import { PageProvider } from '../../context/PageContext';
import { NotificationProvider } from '../../context/NotificationContext';
import { unlockNotificationAudio } from '../../services/notificationSoundService';
const FULL_HEIGHT_ROUTES = ['/kanban'];

export default function Layout() {
  const { pathname } = useLocation();
  const isFullHeight = FULL_HEIGHT_ROUTES.some((p) => pathname === p || pathname.startsWith(`${p}/`));

  useEffect(() => {
    const unlock = () => { unlockNotificationAudio(); };
    document.addEventListener('click', unlock, { once: true });
    document.addEventListener('touchstart', unlock, { once: true });
    document.addEventListener('keydown', unlock, { once: true });
    return () => {
      document.removeEventListener('click', unlock);
      document.removeEventListener('touchstart', unlock);
      document.removeEventListener('keydown', unlock);
    };
  }, []);

  return (
    <PageProvider>
      <NotificationProvider>
      <div className="min-h-screen bg-surface-50">
        {/* Subtle background — Chairside pattern */}
        <div className="fixed inset-0 bg-dots-light opacity-40 pointer-events-none" />
        <div className="fixed top-0 right-0 w-[600px] h-[600px] pointer-events-none">
          <div className="absolute inset-0 bg-gradient-radial from-brand-500/5 via-transparent to-transparent" />
        </div>

        <div className="relative flex h-screen min-h-0 overflow-hidden">
          <Sidebar />

          {/* Content column — pt-14 on mobile clears the fixed mobile top bar */}
          <div className="flex-1 flex flex-col min-h-0 overflow-hidden pt-14 lg:pt-0">
            <ContextBar />

            <main
              className={clsx(
                'flex-1 min-h-0',
                isFullHeight ? 'overflow-hidden' : 'overflow-y-auto overflow-x-hidden',
              )}
            >
              <div
                className={clsx(
                  isFullHeight
                    ? 'h-full flex flex-col min-h-0 overflow-hidden pl-4 pb-0 pr-0 pt-3 sm:pl-6 sm:pt-4 lg:pl-8'
                    : 'min-h-full p-4 sm:p-6 lg:p-8',
                )}
              >
                <div
                  className={clsx(
                    'opacity-0 animate-fade-in',
                    isFullHeight && 'flex-1 min-h-0 flex flex-col overflow-hidden',
                  )}
                  style={{ animationFillMode: 'forwards' }}
                >
                  <Outlet />
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
      </NotificationProvider>
    </PageProvider>
  );
}
